<template>
  <div>
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <div class="body flex-grow-1">
        <router-view :key="$route.fullPath"/>
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar,
  },
  mounted(){
    const context = this
    this.$store.dispatch("REQUEST_COMMON_DATA");
  },
  beforeUnmount(){
      this.$store.commit("REQUEST_COMMON_DATA_INIT")
  },
}
</script>
